<div class="banners-list-container" *ngIf="!isBannerConfigVisible && !isGeneratedURLVisible">
  <div class="banner-info-container">
    <h3>{{ 'view_translations.banner_info_text' | translate }}</h3>
  </div>

  <div class="select-size-container" id="selectMenu">
    <form [formGroup]="selectBannerSizeForm">
      <ng-select
        [searchable]="false"
        notFoundText="{{ 'view_translations.no_data' | translate }}"
        placeholder="{{ 'view_translations.all_sizes_label' | translate }}"
        class="select-menu grey-background"
        [items]="bannersAvailableSizes"
        bindLabel="resolution"
        bindValue="resolution"
        (change)="selectBannersSize($event)"
        formControlName="bannerSize">
      </ng-select>
    </form>
  </div>

  <div class="loader-wrapper" *ngIf="!isLoaded">
    <app-loader></app-loader>
  </div>
  <div *ngIf="isLoaded" class="banners-list" (scroll)="checkIfScrolled($event)">
    <div class="inner-container">
      <div class="single-banner" *ngFor="let banner of bannersList">
        <app-single-banner [bannerData]="banner" (selectedBannerData)="switchSelectedBanner($event)"> </app-single-banner>
      </div>
    </div>
    <div class="modal-inner-container-mask" *ngIf="!scrolledToBottom"></div>
  </div>
</div>
<div class="banner-configuration-container" *ngIf="isBannerConfigVisible">
  <app-configuration-created
    [currentCampaign]="currentCampaign"
    [selectedConfigData]="selectedBannerData"
    (emitConfiguration)="addBanner($event)"
    (backToBannersList)="changeVisibility($event)"
    [isSuccessfullySubmitted]="isSuccessfullySubmitted"
    [noWayBack]="noWayBack"
    [configurationData]="bannerConfigurationData"
    [component]="'banners'">
  </app-configuration-created>
</div>
